import {FeatureObject} from '../../types/FeatureObject';
import {FeatureStatus} from '../../types/FeatureStatus';

/**
 * Filter features by excluded statuses
 * @param excludeStatus
 * @returns
 */
export function filterByExcludeStatus(excludeStatus?: FeatureStatus[]): (f: FeatureObject) => boolean {
  return (f) => !excludeStatus || !excludeStatus.includes(f.status);
}
